"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TbWarnDialog = void 0;
var react_1 = __importDefault(require("react"));
var TbDialog_1 = require("./TbDialog");
var TbWarnDialog = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Warning' : _b, message = _a.message, open = _a.open, handleClose = _a.handleClose, handleSubmit = _a.handleSubmit, submitButton = _a.submitButton, closeButton = _a.closeButton;
    return (react_1.default.createElement(TbDialog_1.TbDialog, { title: title, message: message, color: 'rgb(218, 71, 37)', open: open, closeButton: closeButton !== null && closeButton !== void 0 ? closeButton : 'CANCEL', handleClose: handleClose, submitButton: submitButton, handleSubmit: handleSubmit }));
};
exports.TbWarnDialog = TbWarnDialog;
//# sourceMappingURL=TbWarnDialog.js.map